import { render, staticRenderFns } from "./WorkOrderProducts.vue?vue&type=template&id=f99de12a&scoped=true"
import script from "./WorkOrderProducts.vue?vue&type=script&lang=js"
export * from "./WorkOrderProducts.vue?vue&type=script&lang=js"
import style0 from "./WorkOrderProducts.vue?vue&type=style&index=0&id=f99de12a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99de12a",
  null
  
)

export default component.exports